import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import P2 from '@base/P2/P2';
import Card from './Card';
import AuthorHeader from './AuthorHeader';

const Message = styled(P2)`
  color: var(--color-text-primary);
  font-size: 12px;
  line-height: 150%;
`;

const StyledCard = styled(Card)`
  margin-top: 16px;
`;

const MessageCard = ({ story, batch }) => {
  const { message, author, created_at, object } = story;
  return (
    <>
      <AuthorHeader
        author={author}
        created_at={created_at}
        subtitle={batch && object?.collection_name}
      />
      <StyledCard>
        <Message>{message}</Message>
      </StyledCard>
    </>
  );
};

export default MessageCard;

MessageCard.propTypes = {
  story: PropTypes.objectOf(PropTypes.any).isRequired,
  batch: PropTypes.bool
};

MessageCard.defaultProps = {
  batch: false
};
